import {
  GET_VISIBILITY,
  SET_GROUP_VISIBILITY,
  SET_SETTING_VISIBILITY,
  VISIBILITY_CHANGED,
  VISIBILITY_FAILED,
} from "./constants";

export const getVisibility = (accountId) => ({
  type: GET_VISIBILITY,
  accountId,
});

export const visibilityChanged = (visibility, accountId) => ({
  type: VISIBILITY_CHANGED,
  visibility,
  accountId,
});

export const visibilityFailed = (accountId) => ({
  type: VISIBILITY_FAILED,
  accountId,
});

// `visible` is what was asked for; the reducer stores the inverse (we persist
// what is hidden, not what is shown).
export const setGroupVisibility = (group, visible) => ({
  type: SET_GROUP_VISIBILITY,
  group,
  visible,
});

export const setSettingVisibility = (setting, visible) => ({
  type: SET_SETTING_VISIBILITY,
  setting,
  visible,
});
